define('js/lib/analytics',[
    'Rollbar',
    'buildtimeConfig',
    'js/lib/mixpanel',
    'js/lib/getUser',
    'vendor/wrapple'
], function (
    Rollbar,
    buildtimeConfig,
    mixpanel,
    getUser,
    wrapple
) {
    'use strict';
    wrapple('location');

    var promise;
    var tokenStripper = /(vizia_access_token=)[^&]*/;

    function noop() {}

    function getRollbarConfig() {
        const baseConfig = {
            accessToken: window.CONFIG.rollbarToken.value,
            captureUncaught: true,
            scrubFields: ['vizia_access_token', 'idToken'],
            scrubTelemetryInputs: true,
            payload: {
                environment: window.CONFIG.env.value,
                javascript: {
                    source_map_enabled: true,
                    guess_uncaught_frames: true,
                    code_version: buildtimeConfig.version || 'development'
                }
            }
        }
        return getUser.getPromise()
            .then(function (user) {
                return Object.assign({}, baseConfig, {
                    payload: {
                        person: {
                            id: user.id
                        },
                        clientId: user.clientId
                    }
                });
            })
            .catch(function (err) {
                console.warn('Failed to get user for Rollbar config, using fallback', err);
                // Return minimal config without user info
                return Object.assign({}, baseConfig);
            });
    }

    function init() {
        return getRollbarConfig()
            .then(function (rollbarConfig) {
                var mixpanelClient;
                var rollbarClient;

                rollbarClient = Rollbar.init(rollbarConfig);
                mixpanel.init();
                mixpanelClient = mixpanel.get();

                return {
                    rollbar: rollbarClient,
                    mixpanel: mixpanelClient
                };
            })
            .catch(function (err) {
                console.warn('Analytics init failed, falling back to minimal clients', err);
                // fallback minimal Rollbar config
                var rollbarClient = Rollbar.init({
                    accessToken: window.CONFIG.rollbarToken.value,
                    captureUncaught: true,
                    scrubFields: ['vizia_access_token', 'idToken'],
                    scrubTelemetryInputs: true,
                    payload: {
                        environment: window.CONFIG.env.value,
                        javascript: {
                            source_map_enabled: true,
                            guess_uncaught_frames: true,
                            code_version: buildtimeConfig.version || 'development'
                        }
                    }
                });
                mixpanel.init();
                var mixpanelClient = mixpanel.get();
                return {
                    rollbar: rollbarClient,
                    mixpanel: mixpanelClient
                };
            });
    }

    function reportRollbarError(client, level) {
        if (!client) {
            return noop;
        }
        return function (msg, error) {
            return client[level](msg || '', error);
        };
    }

    function reportMixpanelEvent(client) {
        if (!client) {
            return noop;
        }
        return function(event, payload) {
            return client.track(event, Object.assign({}, payload, {
                $current_url: wrapple('location').href.replace(tokenStripper, '$1REDACTED')
            }));
        };
    }

    return {
        promise: function () {
            if (promise) {
                return promise;
            }
            promise = init().then(function (clients) {
                return {
                    errors: {
                        debug: reportRollbarError(clients.rollbar, 'debug'),
                        info: reportRollbarError(clients.rollbar, 'info'),
                        warn: reportRollbarError(clients.rollbar, 'warn'),
                        error: reportRollbarError(clients.rollbar, 'error')
                    },
                    track: reportMixpanelEvent(clients.mixpanel)
                };
            });
            return promise;
        }
    };
});
